export const CONTACT = {
  phoneDisplay: "+359 888 41 52 19",
  phoneHref: "tel:+359888415219",
  whatsapp: "https://wa.me/359888415219",
  viber: "viber://chat?number=%2B359888415219",
  email: "office@purtier.bg",
  emailHref: "mailto:office@purtier.bg",
};

export const IMAGES = {
  portrait: "/images/portrait.webp",
  productBox: "/images/purtier-real.webp",
  productCapsules: "/images/product-capsules.webp",
};

export const NAV = [
  { path: "/", label: "Начало", testid: "nav-home" },
  { path: "/za-men", label: "За мен", testid: "nav-about" },
  { path: "/purtier", label: "PURTIER", testid: "nav-purtier" },
  { path: "/priemat", label: "Как е устроен приемът", testid: "nav-process" },
  { path: "/faq", label: "FAQ", testid: "nav-faq" },
  { path: "/blog", label: "Блог", testid: "nav-blog" },
  { path: "/kontakti", label: "Контакти", testid: "nav-contact" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
